import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {BehaviorSubject, Subscription} from 'rxjs';
import {
  MultipleSelectFilterComponent
} from '../../../../../../core/component/multiple-select-filter/multiple-select-filter.component';
import {SelectFilterElement} from '../../../../../../../components/common/select-filter/select-filter.model';
import {NewItemModalOptions} from '../../../../../../core/component/select/abstract-select.component';
import {Operator, Order, Sort} from '../../../../../../../shared/utils/url.builder';
import {LovValueModalOptions} from '../../model/lovValueModalOptions';
import {
  LovValueSaveDialogInput,
  LovValueSaveDialogResult,
  LovValueUpdateModalComponent
} from '../lov-value-update-modal/lov-value-update-modal.component';
import {TriggerModalCapable} from '../../../../../../../components/common/modal/triggerModalCapable';
import {UrlParameterBuilder} from '../../../../../../core/http/UrlParameterBuilder';
import {LovValueSummary} from '../../model/lovValueSummary.model';
import {LovValueSummaryFindAllService} from '../../../impl/service/lovValueSummaryFindAll.service';

@Component({
  selector: 'app-lov-values-select-filter',
  templateUrl: './lov-values-select-filter.component.html',
  // FIXME find a solution to a cache.
  providers: [LovValueSummaryFindAllService]
})
export class LovValuesSelectFilterComponent implements OnInit, TriggerModalCapable<LovValueModalOptions>, OnDestroy {


  @ViewChild('multipleSelectFilterComp') multipleSelectFilterComponent: MultipleSelectFilterComponent<string, LovValueSummary>;
  @Input() parentFormGroup: UntypedFormGroup;
  @Input() parentFormControlName: string;
  @Input() lovListName: string;
  @Input() hideChildren = false;
  @Input() lovValuesToIgnore: LovValueSummary[] = [];
  @Input() elementsPerPage: 10;
  @Input() newItemModalOptions: LovValueModalOptions;
  @Input() sort: Sort;

  loadingElements = true;
  lovValues: BehaviorSubject<SelectFilterElement<string, LovValueSummary>[]> =
      new BehaviorSubject<SelectFilterElement<string, LovValueSummary>[]>([]);

  subscriptions: Subscription[] = [];

  constructor(private service: LovValueSummaryFindAllService) { }

  ngOnInit() {
    this.service.parameters = new UrlParameterBuilder()
        .addParameter('list.name', this.lovListName, Operator.EQUALS)
        .parameters;

    this.subscriptions.push(this.service.entities$.subscribe(entities => {
      let values: LovValueSummary[] = [];
      if (entities) {
        // Remove children if requested
        const filteredResults = entities.filter((lovValue) => !this.hideChildren || (this.hideChildren && !lovValue.parentLabel));
        // Ignore provided lov values
        const lovValueIdsToIgnore = this.lovValuesToIgnore.map(value => value.id);
        values = filteredResults.filter(lovValue => lovValueIdsToIgnore.indexOf(lovValue.id) === -1);
      }

      this.lovValues.next(values.map(lovValue => {
        return new SelectFilterElement(lovValue.value, lovValue.value, lovValue);
      }));

    }));
    this.subscriptions.push(this.service.loading$.subscribe(value => this.loadingElements = value));

    this.service.sort = this.sort ? this.sort : new Sort('index,label', Order.ASCENDING);
    this.service.findAll();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(value => value.unsubscribe());
  }

  filterLovValues = (criteria: string, lovValue: LovValueSummary) => {
    return lovValue.label.toUpperCase().includes(criteria.toUpperCase());
  }

  get filterInput(): string {
    return this.multipleSelectFilterComponent.filterInput;
  }

    get formattedNewItemModalOptions():
        NewItemModalOptions<LovValueSaveDialogResult, LovValueSaveDialogInput, LovValueUpdateModalComponent> {
      return this.newItemModalOptions ? ({
        valueNewItemMapper: this.valueNewItemMapper,
        componentType: LovValueUpdateModalComponent,
        dialogOption: {
          title: 'Créer ' + this.newItemModalOptions.title,
        },
        dialogInput: {
          lovListName: this.lovListName
        }
      }) : undefined;
    }

    valueNewItemMapper = (result: LovValueSaveDialogResult) => {
        return result?.lovValue?.summary?.value;
    }

  get elementControl() {
    return this.parentFormGroup.get(this.parentFormControlName);
  }
}
